var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47 22 2 17.53 2 12S6.47 2 12 2s10 4.47 10 10-4.47 10-10 10zm0-18.824c-4.824 0-8.824 4-8.824 8.824 0 4.823 4 8.823 8.824 8.823 4.823 0 8.823-4 8.823-8.823 0-4.824-4-8.824-8.823-8.824z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.412c-.353 0-.588-.235-.588-.588V3.175c0-.352.235-.588.588-.588s.589.236.589.588V20.94c0 .236-.236.47-.589.47z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.823 12.588H3.176c-.353 0-.588-.235-.588-.588s.235-.588.588-.588h17.765c.353 0 .588.235.588.588s-.353.588-.706.588z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.822 21.765C8.116 20.823 6.116 16.823 6.116 12c0-4.941 2-8.941 4.706-9.765l1.764.353c0 .353-.235.588-.588.588-2.588 0-4.706 4-4.706 8.824 0 4.823 2.118 8.823 4.706 8.823.353 0 .588.236.588.589l-1.764.353z",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.412 21.412c0-.353.235-.588.588-.588 2.589 0 4.706-4 4.706-8.824S14.59 3.176 12 3.176c-.353 0-.588-.235-.588-.588l1.53-.47c2.823.706 4.94 4.823 4.94 9.882 0 4.941-2 8.941-4.705 9.765l-1.765-.353z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language-icon.5e4c955e348d3267a115fb44b1015673.svg";
export { ForwardRef as ReactComponent };